import NotificationSettings from '../../components/notification-settings';

export default function NotificationsPage() {
  return (
    <div>
      <h1 className="text-lg font-semibold mb-4">Notifications</h1>
      <NotificationSettings />
    </div>
  );
}
